import React from "react";
import CrudTable from "../components/CrudTable";
import { formatINR } from "../lib/api";

const columns = [
  { key: "name", label: "Partner" },
  { key: "capital_type", label: "Type" },
  { key: "contact_person", label: "Contact" },
  { key: "total_commitment", label: "Committed", render: (v) => formatINR(v || 0) },
  { key: "capital_deployed", label: "Deployed", render: (v) => formatINR(v || 0) },
  { key: "available_capital", label: "Available", render: (v) => formatINR(v || 0) },
  { key: "interest_rate", label: "IRR %" },
  { key: "status", label: "Status", status: true },
];
const formFields = [
  { name: "name", label: "Company Name", required: true },
  { name: "contact_person", label: "Contact Person" },
  { name: "email", label: "Email", type: "email", required: true },
  { name: "phone", label: "Phone" },
  { name: "capital_type", label: "Capital Type", type: "select", default: "NBFC",
    options: ["NBFC", "Bank", "Family Office", "Individual Investor", "Institutional Investor", "Entity Investor"].map((s) => ({ value: s, label: s })) },
  { name: "total_commitment", label: "Total Commitment (₹)", type: "number", default: 0 },
  { name: "capital_deployed", label: "Capital Deployed (₹)", type: "number", default: 0 },
  { name: "interest_rate", label: "Interest Rate (%)", type: "number", default: 10 },
  { name: "tenure_months", label: "Tenure (months)", type: "number", default: 36 },
  { name: "next_payout_date", label: "Next Payout Date", type: "date" },
  { name: "status", label: "Status", type: "select", default: "active",
    options: [{ value: "active", label: "Active" }, { value: "paused", label: "Paused" }, { value: "terminated", label: "Terminated" }] },
];

export default function CapitalPartners() {
  return <CrudTable
    title="Capital Partners"
    description="Every funding source powering RushGro's asset base — NBFCs, banks, family offices, investors."
    endpoint="/capital-partners" columns={columns} formFields={formFields} />;
}
